import React, {useState} from "react"
import {Button} from "@mui/material"
import styled from "styled-components"

import {ResetExtensionConfirmModal} from "./ResetExtensionConfirmModal"

import {api} from "@indebted/api"
import {useAgent} from "@indebted/hooks/Agent"

type ResetInstalmentCapButtonProps = {
	customerID: string
	onResetSuccess: () => void
	onResetError: (error: string) => void
}

const ResetInstalmentCapButton = ({customerID, onResetSuccess, onResetError}: ResetInstalmentCapButtonProps) => {
	const [resetModalOpen, setResetModalOpen] = useState(false)
	const [agentEmail] = useAgent()

	const handleResetClick = () => {
		setResetModalOpen(true)
	}

	const handleModalClose = () => {
		setResetModalOpen(false)
	}

	const handleResetConfirm = async () => {
		try {
			await api.customer.resetInstalmentCap(customerID, agentEmail)
			setResetModalOpen(false)
			onResetSuccess()
		} catch (err: any) {
			const errorMessage = err?.Message || "Failed to reset instalment cap"
			onResetError(errorMessage)
			console.error("Error resetting instalment cap:", err)
			setResetModalOpen(false)
		}
	}

	return (
		<>
			<ResetButton variant="contained" onClick={handleResetClick} size="small">
				RESET TO DEFAULT
			</ResetButton>
			<ResetExtensionConfirmModal
				open={resetModalOpen}
				onClose={handleModalClose}
				onConfirm={handleResetConfirm}
			/>
		</>
	)
}

const ResetButton = styled(Button)`
	text-transform: uppercase;
	font-weight: 500;
	font-size: 0.875rem;
	letter-spacing: 0.4px;
	background-color: #dc2626;
	color: white;

	&:hover {
		background-color: #b91c1c;
	}
`
export {ResetInstalmentCapButton}
